<template>
  <layout-animated-underline-component
    :to="{ name: routeName, params: { slug: entry?.slug }, query: route?.query }"
    :active="active ||entry?.slug === $route?.params?.slug"
    :ignore="entry?.slug === $route?.params?.slug"
  >
    <template #default>
      {{ label }}
    </template>
  </layout-animated-underline-component>
</template>

<script lang="ts" setup>
const route = useRoute()

const props = defineProps({
  entry: {
    type: Object,
    required: true
  },
  label:  {
    type: [String, Number],
    required: true
  },
  active: {
    type: Boolean,
    default: false
  }
})

const currentSlug = computed(() => route?.params?.slug)
const routeName = computed(() => getRouteName() === 'editions' ? 'editions-slug-index-about' : getRouteName())
</script>
